import { render, staticRenderFns } from "./shopsInfo.vue?vue&type=template&id=739aa7db&scoped=true&"
import script from "./shopsInfo.vue?vue&type=script&lang=js&"
export * from "./shopsInfo.vue?vue&type=script&lang=js&"
import style0 from "./shopsInfo.vue?vue&type=style&index=0&id=739aa7db&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739aa7db",
  null
  
)

export default component.exports